export const volunteersData = [
          {
                    id: 1,
                    image: "https://img.freepik.com/free-photo/pleased-young-female-doctor-wearing-medical-robe-stethoscope-around-neck-standing-with-closed-posture_409827-254.jpg?w=2000",
                    name: "Jessica Brown",
                    designation: "Volunteer"
          },
          {
                    id: 2,
                    image: "https://media.istockphoto.com/id/1327024466/photo/portrait-of-male-doctor-in-white-coat-and-stethoscope-standing-in-clinic-hall.jpg?b=1&s=170667a&w=0&k=20&c=3GoWF_QG3WZoJK6CJWWY9Cxt5s6O-0I6qrU1QCnloKA=",
                    name: "Mike Hardson",
                    designation: "Volunteer"
          },
          {
                    id: 3,
                    image: "https://media.istockphoto.com/id/1366374033/photo/shot-of-a-young-doctor-using-a-digital-tablet-in-a-modern-hospital.jpg?b=1&s=170667a&w=0&k=20&c=I3nSyS-hAorfMhDCXrv16JyQ7VYgaFr7rrZDW2bC-qs=",
                    name: "Christine Eve",
                    designation: "Volunteer"
          },
          {
                    id: 4,
                    image: "https://post.healthline.com/wp-content/uploads/2020/09/Black_Male_Doctor_Portrait_732x549-thumbnail.jpg",
                    name: "David Partson",
                    designation: "Volunteer"
          },
          {
                    id: 5,
                    image: "https://media.istockphoto.com/id/1346124955/photo/mature-doctor-holding-medical-records-at-hospital.jpg?b=1&s=170667a&w=0&k=20&c=4pnYmVxAusl-v4iitz-mHw69d5O5oGGDtnvq0ib0QTk=",
                    name: "Johnny Ross",
                    designation: "Volunteer"
          },
          {
                    id: 6,
                    image: "https://media.istockphoto.com/photos/doctor-holding-digital-tablet-at-meeting-room-picture-id1189304032?b=1&k=20&m=1189304032&s=612x612&w=0&h=3IlZQ_IDMJDkjPCThsflr8vmCZVPmxXPWLzsxb8rShQ=",
                    name: "Helen Nean",
                    designation: "Volunteer"
          },
          {
                    id: 7,
                    image: "https://t3.ftcdn.net/jpg/03/08/95/96/360_F_308959677_9dsUpeKnj2wWy42Vr8ofYNeKoazLXgSX.jpg",
                    name: "Mariron Hon",
                    designation: "Volunteer"
          },
          {
                    id: 8,
                    image: "https://familydoctor.org/wp-content/uploads/2018/02/41808433_l.jpg",
                    name: "David Partson",
                    designation: "Volunteer"
          }
];